import getters from '$$store/massChange/getters';
import mutations from '$$store/massChange/mutations';
import actions from '$$store/massChange/actions';

const MassChangeStore = {
  namespaced: true,
  state: {
    isEnabled: false,
    selectedItems: [],
  },
  getters,
  mutations,
  actions,
};

export default MassChangeStore;
